<template>
  <div class="stripe-pay-component">
    <div class="row">
      <div class="col-12">
        <h4>Authorise Your Payment Method</h4>
        <div v-if="paid" class="alert alert-success mb-0">
          Your payment has been taken successfully.
        </div>
        <div v-if="authed" class="alert alert-success mb-0">
          You have successfully pre-authorised your payment method, Castle Green will be in touch shortly to proceed.
        </div>
        <form v-if="!paid && !authed" id="payment-form" ref="payment-form">
          <p><strong>Total:</strong> £{{ payment.total | money }}</p>

          <div class="d-flex flex-column flex-lg-row align-items-start w-100">
            <div class="flex-grow-1 me-2 w-100 w-xl-auto">
              <div id="card-element" class="mb-3">
                <!-- Elements will create input elements here -->
              </div>

              <!-- We'll put the error messages in this element -->
              <div
                id="card-errors"
                class="alert alert-danger d-none mb-3"
                role="alert"
              ></div>
            </div>

            <button class="btn btn-primary" id="submit" :disabled="loading">
              Pre-Authorise
            </button>
          </div>

          <small class="text-muted">You will not be charged at this time.</small>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js/pure';

export default {
  data() {
    return {
      loading: false,
      stripe: null,
      elements: null,
      card: null,
      authed: false,
    };
  },

  props: {
    publishableKey: {
      type: String,
      default: null,
    },
    clientSecret: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    paid: {
      type: Boolean,
      default: false,
    },
    payment: {
      type: Object,
      default: null,
    },
  },

  created() {
    if (this.paid) {
      return;
    }

    if (this.payment.capturable) {
      this.authed = true;
      return;
    }

    this.loadStripeAsync().then(() => {
      this.elements = this.stripe.elements();

      // Styles.
      const style = {
        base: {
          color: "#212721",
          fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
          fontSize: "14px",
          // backgroundColor: '#ffffff',
          // padding: '15px 20px',
        },
      };

      // Create the card element.
      this.card = this.elements.create("card", {
        hidePostalCode: true,
        style: style,
      });
      this.card.mount("#card-element");

      // Validation.
      this.card.on("change", ({ error }) => {
        let displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
          $("#card-errors").removeClass("d-none");
        } else {
          displayError.textContent = "";
          $("#card-errors").addClass("d-none");
        }
      });

      this.$refs["payment-form"].addEventListener("submit", (ev) => {
        ev.preventDefault();

        if (this.loading) {
          return;
        }

        this.loading = true;

        // If the client secret was rendered server-side as a data-secret attribute
        // on the <form> element, you can retrieve it here by calling `form.dataset.secret`
        this.stripe
          .confirmCardPayment(this.clientSecret, {
            payment_method: {
              card: this.card,
              billing_details: {
                name: this.user.name,
                email: this.user.email,
              },
            },
          })
          .then((result) => {
            if (result.error) {
              // Show error to your customer (e.g., insufficient funds)
              console.log("Friendly error", result.error.message);

              notyf.error(result.error.message);

              this.loading = false;
            } else {
              // The payment has been processed!
              notyf.success("You have successfully authorised your payment method.");
              this.authed = true;
            }
          })
          .catch((err) => {
            // Show error to your customer
            console.log("Error caught", err);

            notyf.error("Something went wrong, please contact support.");

            this.loading = false;
          });
      });
    });
  },

  methods: {
    async loadStripeAsync() {
      this.stripe = await loadStripe(this.publishableKey);
    },
  },
};
</script>
